import { render, staticRenderFns } from "./dealwithInfo.vue?vue&type=template&id=24a22466&scoped=true&"
import script from "./dealwithInfo.vue?vue&type=script&lang=js&"
export * from "./dealwithInfo.vue?vue&type=script&lang=js&"
import style0 from "./dealwithInfo.vue?vue&type=style&index=0&id=24a22466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a22466",
  null
  
)

export default component.exports